import { nanoid } from "nanoid";

// HEAD DATA
export const headData = {
  title: "Prescott Sun | Software Engineer", // e.g: 'Name | Developer'
  lang: "en", // e.g: en, es, fr, jp
  description: "Prescott's portfolio site", // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: "Hi, I'm",
  name: "Prescott Sun",
  subtitle: "Software Engineer",
  cta: "More about me",
};

// ABOUT DATA
export const aboutData = {
  img: "profile.jpg",
  paragraphOne:
    "A lifelong computer and tech enthusiast. I graduated from the University of Connecticut with a Bachelor of Science in mechanical engineering. I moved to Atlanta for my first job out of school, working as a business intelligence analyst. At school and on the job, I always found the work I did involving programming to be the most interesting and fulfilling. I wrote scripts to solve math problems in Matlab, created macros in Visual Basic to automate tasks in Excel, and made SQL queries to parse business order data for analysis.",
  paragraphTwo:
    "My passion for programming led me to pursue a career in software engineering, by first completing DigitalCrafts’ coding bootcamp. At the bootcamp I learned more programming fundamentals and developed full stack web applications, working on my own and as a team member. Since completing the bootcamp, I have continued learning on my own, building projects, and familiarizing myself with new technologies. Now I want to join an engineering team where I’ll be able to apply my skills in a more meaningful way and continue developing as a software engineer.",
  paragraphThree: "",
  resume: "https://drive.google.com/file/d/1mQ7_OuMDMAEyHubdNZkJs-Lx9blRsmtl/view?usp=sharing", // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: "paperless_bookshelf.png",
    title: "Paperless Bookshelf",
    info:
      "A digital bookshelf app for users to discover books and authors, create personalized bookshelves, and read book previews. The application is built with React, Context, Firestore, Google auth, Material UI. Features include Goodreads and Google Books API integration, manageable user bookshelves, search functionality, book previews, book/author detail pages with ratings and reviews.",
    info2: "",
    url: "https://paperless-bookshelf.netlify.app",
    repo: "https://github.com/prescottsun/paperless-bookshelf", // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: "codetrain_messages.png",
    title: "CodeTrain",
    info:
      "A community platform for coding bootcamp students to share learning resources and prospective employers to post their job listings and connect with students. Built with the PERN stack. Features include:",
    info2: `
      <ul>
        <li>Three different user roles (student, company, admin) with unique functionality and views.</li>
        <li>User account creation and user auth through Passport.js.</li>
        <li>Learning resource and job listing boards with full CRUD capabilities.</li>
        <li>Job application functionality. Bootcampers apply to job listings. Company users review applications to go forward in the hiring process.</li>
        <li>User messaging and issue reporting system.</li>
      </ul>
      `,
    url: "https://codetrain.herokuapp.com",
    repo: "https://github.com/prescottsun/codetrain", // if no repo, the button will not show up
  },
  {
    id: nanoid(),
    img: "city_stats.png",
    title: "City Stats",
    info:
      "An urban area metrics site for prospective residents looking to move to a new city. Users can search for cities by name or select from a list of urban cities. The site utilizes the <a href='https://developers.teleport.org/api/'>Teleport API</a> for its various quality of life indexes. The application is built with the PERN stack. Users can login with their Google accounts with Firebase.",
    info2: "",
    url: "https://prescottsun.github.io/city-stats",
    repo: "https://github.com/prescottsun/city-stats", // if no repo, the button will not show up
  },
  // {
  //   id: nanoid(),
  //   img: "code_log.png",
  //   title: "Code.log",
  //   info:
  //     "An extracurricular activity logging website for programming students to post, share, and review different resources they’ve used to learn coding. The website's backend is built with Node.js, Express, and PostgreSQL. Features include login authentication, profile pages, a recent activity feed, resource information pages, and reviews. Data is posted to and read from a SQL database.",
  //   info2: "",
  //   url: "",
  //   repo: "https://github.com/prescottsun/code-log", // if no repo, the button will not show up
  // },
  {
    id: nanoid(),
    img: "bus_talker.png",
    title: "BusTalker",
    info:
      "A MARTA bus and rail tracking web page with real-time location, arrival, and weather updates. The application uses MARTA's APIs to display relevant bus and train status information to commuters. LeafletJS and CanvasJS libraries are used to display current Marta bus locations and statuses. Styled using CSS and Bootstrap.",
    info2: "",
    url: "https://bustalker.com",
    repo: "https://github.com/prescottsun/bus-talker", // if no repo, the button will not show up
  },
  // {
  //   id: nanoid(),
  //   img: "space_force_prime.png",
  //   title: "Space Force Prime",
  //   info:
  //     "A space shoot 'em up made in Python with the Pygame library.The player's score increases with each successful package delivery to a friendly and each enemy hit with a laser ship. The player's health decreases when hit by an enemy or asteroid. The game becomes more difficult as the player's score increases.",
  //   info2: "",
  //   url: "",
  //   repo: "https://github.com/cobidev/react-simplefolio", // if no repo, the button will not show up
  // },
];

// CONTACT DATA
export const contactData = {
  cta: "Location: Atlanta, GA",
  btn: "sunprescott@gmail.com",
  email: "sunprescott@gmail.com",
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: "linkedin",
      url: "https://www.linkedin.com/in/prescott-sun/",
    },
    {
      id: nanoid(),
      name: "github",
      url: "https://github.com/prescottsun",
    },
  ],
};
